import { HelpOutline, Menu as MenuIcon, AccountCircle } from '@mui/icons-material'
import { AppBar, Button, IconButton, Menu, MenuItem, Toolbar, Typography } from '@mui/material'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'

import logo from 'logo.svg'
import logoFr from 'logo-fr.svg'

import { PIPELINE_PAGE, SEARCH_PAGE, USER_PROFILE } from 'utils/paths'

import { logoutUser } from 'store/actions/user'
import { selectHasExecutePermissions } from 'store/selectors/user'

const HeaderBar = ({ onLeftIconButtonClick, history }) => {
  const { t, i18n } = useTranslation()

  const [showAccountMenu, setShowAccountMenu] = useState(false)
  const [anchorEl, setAnchorEl] = useState(null)

  const dispatch = useDispatch()
  const { isAuthenticated } = useSelector(state => state.user)
  const hasExecutePermissions = useSelector(selectHasExecutePermissions)

  const languageSwitchString = i18n.language === 'en' ? 'FR' : 'EN'
  const logoSrc = i18n.language === 'en' ? logo : logoFr

  const handleAccountMenuClick = e => {
    e.preventDefault()
    setShowAccountMenu(true)
    setAnchorEl(e.currentTarget)
  }

  const handleLanguageSwitch = () => {
    const newLang = i18n.language === 'en' ? 'fr' : 'en'

    // Update localstorage state for new language at next page load
    localStorage.setItem('lang', newLang)

    // Reload page to get new language content from the API
    history.go(0)
  }

  const logoImg = <img src={logoSrc} className="App-logo" alt="logo" />
  const logoLink = isAuthenticated
    ? hasExecutePermissions
      ? PIPELINE_PAGE
      : SEARCH_PAGE
    : t('global.salesSiteUrl')

  return (
    <AppBar position="static">
      <Toolbar className="Header-wrapper">
        {isAuthenticated && hasExecutePermissions ? (
          <IconButton edge="start" onClick={onLeftIconButtonClick}>
            <MenuIcon className="Header-icon" />
          </IconButton>
        ) : (
          <></>
        )}
        <Typography marginRight="auto">
          {isAuthenticated ? (
            <Link to={logoLink}>{logoImg}</Link>
          ) : (
            <a href={logoLink} rel="noopener">
              {logoImg}
            </a>
          )}
        </Typography>
        <div className="tw-flex tw-items-center tw-content-center">
          <div style={{ width: '30px' }}>
            <a className="tw-block" href={t('leftMenu.help_center_url')} target="_blank">
              {<HelpOutline data-class="Header-help" />}
            </a>
          </div>
          <Button
            style={{ minWidth: '44px', height: '100%' }}
            className="tw-w-4 tw-min-w-4"
            onClick={handleLanguageSwitch}
            variant="text"
          >
            {languageSwitchString}
          </Button>
          {/* Account Menu */}
          {isAuthenticated && (
            <>
              <div>
                <IconButton onClick={handleAccountMenuClick}>
                  <AccountCircle className="Header-icon-account" />
                </IconButton>
              </div>
              <Menu
                open={showAccountMenu}
                anchorEl={anchorEl}
                onClose={() => setShowAccountMenu(false)}
                className="Header-popover"
              >
                {hasExecutePermissions && (
                  <Link to={USER_PROFILE}>
                    <MenuItem>{t('user.profile.myAccount')}</MenuItem>
                  </Link>
                )}
                <MenuItem onClick={() => dispatch(logoutUser())}>{t('user.logout')}</MenuItem>
              </Menu>
            </>
          )}
        </div>
      </Toolbar>
    </AppBar>
  )
}

export default HeaderBar
